import { useState } from "react";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
//import Divider from "@mui/material/Divider";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import CategoryIcon from "@mui/icons-material/Category";
import TimerIcon from "@mui/icons-material/Timer";

import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

import FiltrosReportes from "./components/FiltrosReportes";
import ReportePorAsesor from "./components/ReportePorAsesor";
import ReportePorSede from "./components/ReportePorSede";
import ReportePorTipo from "./components/ReportePorTipo";
import ReporteTiemposGestion from "./components/ReporteTiemposGestion";

/**
 * Componente principal de la página de reportes
 * Organiza diferentes tipos de reportes en tabs
 */
function Reportes() {
  const [tabActivo, setTabActivo] = useState(0);
  const [filtros, setFiltros] = useState({});
  const [recargarKey, setRecargarKey] = useState(0);

  const handleCambiarTab = (event, nuevoTab) => {
    setTabActivo(nuevoTab);
  };

  const handleAplicarFiltros = (nuevosFiltros) => {
    setFiltros(nuevosFiltros);
    setRecargarKey((prev) => prev + 1);
  };

  const handleLimpiarFiltros = () => {
    setFiltros({});
    setRecargarKey((prev) => prev + 1);
  };

  const handleRefrescar = () => {
    setRecargarKey((prev) => prev + 1);
  };

  // Determinar el tipo de reporte actual para mostrar filtros relevantes
  const tiposReporte = [
    "REPORTES_POR_ASESOR",
    "REPORTES_POR_SEDE",
    "REPORTES_POR_TIPO",
    "REPORTES_TIEMPOS_GESTION",
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox py={1}>
        {/* Header */}
        {/* <SuiBox mb={3}>
          <Card>
            <SuiBox p={3}>
              <SuiBox display="flex" alignItems="center" mb={1}>
                <AssessmentIcon fontSize="large" color="primary" sx={{ mr: 1.5 }} />
                <SuiTypography variant="h4" fontWeight="medium">
                  Módulo de Reportes
                </SuiTypography>
              </SuiBox>
              <SuiTypography variant="button" textColor="text" fontWeight="regular">
                Análisis y estadísticas de procesos de conciliación
              </SuiTypography>
            </SuiBox>
            <Divider />
          </Card>
        </SuiBox> */}

        {/* Filtros */}
        <SuiBox mb={1}>
          <SuiBox p={1}>
            <SuiBox display="flex" alignItems="center" mb={1}>
              <AssessmentIcon fontSize="large" color="primary" sx={{ mr: 1.5 }} />
              <SuiTypography variant="h4" fontWeight="medium">
                Módulo de Reportes
              </SuiTypography>
              <SuiTypography variant="button" textColor="text" fontWeight="regular" sx={{ ml: 2 }}>
                Análisis y estadísticas de los procesos
              </SuiTypography>
            </SuiBox>
          </SuiBox>
          <FiltrosReportes
            onAplicarFiltros={handleAplicarFiltros}
            onLimpiarFiltros={handleLimpiarFiltros}
            onRefrescar={handleRefrescar}
            filtrosActivos={filtros}
            tipoReporte={tiposReporte[tabActivo]}
            autoActualizacion={false}
          />
        </SuiBox>

        {/* Tabs de Reportes */}
        <Card>
          {/* <SuiBox p={1}>
            <SuiTypography variant="h5" fontWeight="medium" mb={2}>
              Tipos de Reportes
            </SuiTypography>
          </SuiBox> */}
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabActivo}
              onChange={handleCambiarTab}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="reportes tabs"
              TabIndicatorProps={{
                sx: { backgroundColor: "#1976d2", height: 3 },
              }}
            >
              <Tab
                icon={<PersonIcon sx={{ color: tabActivo === 0 ? "#1976d2" : undefined }} />}
                iconPosition="start"
                label="Por Asesor"
                sx={{
                  textTransform: "none",
                  fontWeight: tabActivo === 0 ? "bold" : "normal",
                  color: tabActivo === 0 ? "#1976d2" : undefined,
                }}
              />
              <Tab
                icon={<BusinessIcon sx={{ color: tabActivo === 1 ? "#66BB6A" : undefined }} />}
                iconPosition="start"
                label="Por Sede"
                sx={{
                  textTransform: "none",
                  fontWeight: tabActivo === 1 ? "bold" : "normal",
                  color: tabActivo === 1 ? "#66BB6A" : undefined,
                }}
              />
              <Tab
                icon={<CategoryIcon sx={{ color: tabActivo === 2 ? "#FFA726" : undefined }} />}
                iconPosition="start"
                label="Por Tipo"
                sx={{
                  textTransform: "none",
                  fontWeight: tabActivo === 2 ? "bold" : "normal",
                  color: tabActivo === 2 ? "#FFA726" : undefined,
                }}
              />
              <Tab
                icon={<TimerIcon sx={{ color: tabActivo === 3 ? "#EF5350" : undefined }} />}
                iconPosition="start"
                label="Tiempos de Gestión"
                sx={{
                  textTransform: "none",
                  fontWeight: tabActivo === 3 ? "bold" : "normal",
                  color: tabActivo === 3 ? "#EF5350" : undefined,
                }}
              />
            </Tabs>
          </Box>

          {/* Contenido de Tabs */}
          <SuiBox p={3}>
            {/* Tab 1: Reporte por Asesor */}
            {tabActivo === 0 && (
              <ReportePorAsesor key={`asesor-${recargarKey}`} filtros={filtros} />
            )}

            {/* Tab 2: Reporte por Sede */}
            {tabActivo === 1 && <ReportePorSede key={`sede-${recargarKey}`} filtros={filtros} />}

            {/* Tab 3: Reporte por Tipo */}
            {tabActivo === 2 && <ReportePorTipo key={`tipo-${recargarKey}`} filtros={filtros} />}

            {/* Tab 4: Reporte de Tiempos de Gestión */}
            {tabActivo === 3 && (
              <ReporteTiemposGestion key={`tiempos-${recargarKey}`} filtros={filtros} />
            )}
          </SuiBox>
        </Card>

        {/* Información adicional */}
        <SuiBox mt={3}>
          <Card>
            <SuiBox p={3}>
              <SuiBox display="flex" alignItems="flex-start">
                <SuiTypography variant="button" fontWeight="bold" mr={1}>
                  Nota:
                </SuiTypography>
                <SuiTypography variant="button" textColor="text" fontWeight="regular">
                  Los reportes se generan en tiempo real basándose en los datos actuales del
                  sistema. Utilice los filtros para obtener información específica por período,
                  asesor, sede o estado. Puede exportar los datos a Excel o PDF usando los botones
                  disponibles en cada reporte.
                </SuiTypography>
              </SuiBox>
            </SuiBox>
          </Card>
        </SuiBox>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Reportes;
